import React from "react";
import { Route, Redirect } from "react-router-dom";

const RouteGuard = ({ component: Component, ...rest }) => {
  function hasValidSession() {
    let validSession = false;

    let sessionId = sessionStorage.getItem("sessionId");

    if (sessionId) {
      validSession = true;
    }

    return validSession;
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        hasValidSession() ? (
          <Component {...props} />
        ) : (
          <Redirect to={{ pathname: "/auth/login" }} />
        )
      }
    />
  );
};

export default RouteGuard;
